import React, { Component } from 'react';

import { BrowserRouter, Route } from 'react-router-dom'
import styled from 'styled-components'

import A from './Page/A'
import C from './Page/C'
import ConnectedDotCollectionRepository from '../Domain/ConnectedDotCollectionRepository'
import withTracker from './withTracker'

const AWithTracker = withTracker(A)

const AppInner = styled.div`
font-family: "Helvetica Neue", sans-serif;
font-weight: 300;
`

class App extends Component {
  constructor(props) {
    super(props)
    this.state = { connectedDotCollections : [] }
    this._renderCWithProps.bind(this)
  }
  
  componentDidMount() {
    ConnectedDotCollectionRepository.all().then(cdcs => {
      this.setState({ connectedDotCollections : cdcs })
    })
  }
  
  render() {
    const { connectedDotCollections } = this.state
    return (
      <AppInner>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
      <div>
      <Route exact path='/' render={ (props) => <AWithTracker connectedDotCollections={connectedDotCollections} {...props} /> }/>
      <Route path='/:plateId/:dotId' render={ (props) => this._renderCWithProps(props) } />
      </div>
      </BrowserRouter>
      </AppInner>
    )
  }

  _renderCWithProps(props) {
    const cdcs = this.state.connectedDotCollections
    if (cdcs.length === 0) {
      return null
    } else {
      const cdc = cdcs.find(cdc => cdc.id === props.match.params.plateId)
      const CWithTracker = withTracker(C)
      return cdc ? <CWithTracker cData={cdc.cDataWith(props.match.params.dotId)} {...props} /> : null
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js